export const arrowHoverStyles = {
  '&:hover [data-arrow-animation], &:focus-visible [data-arrow-animation], &:focus-within [data-arrow-animation]': {
    transform: 'translateX(4px)',
  },
  '&:hover [data-arrow-animation-line], &:focus-visible [data-arrow-animation-line], &:focus-within [data-arrow-animation-line]': {
    strokeDashoffset: 0,
  },
};

export const imageZoomHoverStyles = {
  '&:hover [data-image-zoom], &:focus-visible [data-image-zoom], &:focus-within [data-image-zoom]': {
    transform: 'scale(1.1)',
  },
};
